import Config from '@/config';

export const IS_QA = Config.APP_ENVIRONMENT === 'QA';
export const IS_PROD = Config.APP_ENVIRONMENT === 'PROD';
